export default class Position {
  constructor() {
    this.left = "50%";
    this.top = "50%";
  }
}
